// @flow
import { getAPIParams, parseSearchParams } from '../../../duck/selectors';

export { getAPIParams, parseSearchParams } from '../../../duck/selectors';

export default {
    getAPIParams,
    parseSearchParams,
};
